module.exports = __webpack_public_path__ + "img/audio_bg.f6b99287.png";